import {inject} from '@angular/core';
import {CanActivateFn, Router} from '@angular/router';
import {Store} from '@ngrx/store';
import {AuthenticationService} from '../../../authentication.service';
import {Features} from '../../../models/plan';
import {ShowToast} from '../../../store/actions';

export const EXTERNAL_FORECAST_NOT_AVAILABLE_KEY = "external.forecast.not.available";

/**
 * Convenience gate for /site-plans-v5/:id/external-forecast (AC-04). The server's feature gate is the
 * real control; this only avoids rendering the page and calling the endpoint when the toggle is off.
 */
export const externalForecastFeatureGuard: CanActivateFn = (route) => {
  if (inject(AuthenticationService).hasFeature(Features.EXTERNAL_FORECAST)) {
    return true;
  }
  const planId = route.parent?.paramMap.get("id") ?? route.paramMap.get("id");
  inject(Store).dispatch(new ShowToast({severity: "warn", detail: EXTERNAL_FORECAST_NOT_AVAILABLE_KEY}));
  return inject(Router).createUrlTree(["/site-plans-v5", planId]);
};
